


















































import deck from '@/store/modules/deck';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({ components: {} })
export default class Notes extends Vue {
  @Prop() readonly currentSlide!: any;

  tab: string = 'note';
  noteText: string = '';

  get slides() {
    return JSON.parse(JSON.stringify(deck.Slides));
  }

  get slide() {
    return this.slides[this.currentSlide - 1];
  }

  get subSlide() {
    if (this.slide && this.slide.subSlides) {
      return this.slide.subSlides[deck.nav.currentSubSlide];
    }
    return null;
  }

  get comment() {
    return this.slide.comment || '';
  }

  @Watch('currentSlide')
  onCurrentSlideChange() {
    this.updateNoteText();
  }

  @Watch('tab')
  onTabChange() {
    this.updateNoteText();
  }

  @Watch('deck.Slides', { deep: true })
  onSlidesChange() {
    this.updateNoteText();
  }

  @Watch('subSlide', { deep: true })
  onSubSlideChange() {
    this.updateNoteText();
  }

  mounted() {
    this.updateNoteText();
    this.$root.$on('deck:currentSubSlideChanged', this.updateNoteText);
    this.$root.$on('deck:tabsReordered', this.updateNoteText);
    this.$root.$on('deck:slidesReordered', this.updateNoteText);
    this.$root.$on('deck:noteUpdated', this.updateNoteText);
  }

  beforeDestroy() {
    this.$root.$off('deck:currentSubSlideChanged', this.updateNoteText);
    this.$root.$off('deck:tabsReordered', this.updateNoteText);
    this.$root.$off('deck:slidesReordered', this.updateNoteText);
    this.$root.$off('deck:noteUpdated', this.updateNoteText);
  }

  updateNoteText() {
    if (this.subSlide) {
      this.noteText = this.subSlide.note || '';
    } else {
      this.noteText = this.slide.note || '';
    }
  }

  updateNote() {
    if (this.subSlide) {
      this.subSlide.note = this.noteText;
    } else {
      this.slide.note = this.noteText;
    }

    deck.updateSlide({
      slide: this.slide,
      index: deck.nav.currentSlide - 1,
    });
  }

  update() {
    deck.updateSlide({
      slide: this.slide,
      index: deck.nav.currentSlide - 1,
    });
  }
}
